import { API_BASE_URL } from "../../config"
import request from "../../utilities/request"

const createWallet = (data) => request.post(`${API_BASE_URL}/blockchain/wallet`, data)

export default createWallet